import { divideAccuracy, goJoinEvent } from "@/lobby_common/utils/utils.js";
import gou from "./gou.png";
export default {
  name: "RankReward",
  props: {},
  data() {
    return {
      divideAccuracy,
      PopupWindowShow: false,
      rewardObj: {},
      gou,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.user;
    },
    coinObj() {
      const arr = this.$store.getters.getPacketConfig?.coinList || [];
      const obj = {};
      arr.map((v) => {
        obj[v.coinCode] = v;
      });
      return obj;
    },
    isAmount() {
      // 免费金币
      return this.rewardObj.rewardType === "ACTIVITY_REWARD_TYPE_MONEY";
    },
    isBet() {
      // 下注次数
      return this.rewardObj.rewardType === "ACTIVITY_REWARD_TYPE_FREE_BET";
    },
  },
  watch: {},
  async created() {},
  methods: {
    show(obj = {}) {
      this.$eventPost("register_success_popup");
      this.rewardObj = {
        ...obj,
        rewardInfo: obj.rewardInfo ? JSON.parse(obj.rewardInfo) : {},
      };
      console.log(this.rewardObj, "this.rewardObj");
      this.PopupWindowShow = true;
    },
    close() {
      this.$eventPost("register_success_close");
      this.PopupWindowShow = false;
      this.rewardObj = {};
      setTimeout(() => {
        this.$popConfig?.initWinConfig(1);
      }, 300);
    },
    handleClick() {
      this.$eventPost("register_success_pay");
      const jump = this.rewardObj.rewardInfo?.jump || {};
      this.PopupWindowShow = false;
      this.$isPopShow({ show: false, views: "" });
      this.$popConfig.endWinConfig();
      this.$Bus.$emit("hideNoticeModal");
      goJoinEvent(jump);
    },
  },
};
